import { CCSETTINGSMENU } from 'app-webtech-core/modules/player/constants';
import { get, camelCase } from 'lodash';

export const getName = (obj) => (obj.name ? obj.name : obj.nameKey);

/*
 * getCCMenu - this will grab the submenu based on the indexArray
 * indexArray: Array - the array of selected indexes to determine the position of where we are in
 * the menu.  I.E [0,1] meansit's in the 2nd submenu on the 2nd menu item in that submenu.
 * currentCCMenu: Array - the array of the current CC menu
 * currentCCmenuName: String - the name of the menu we are currently on
 * showReset: Bool - boolean ot determine if we will be showing the Reset option in the 2nd submenu
 */
export const getCCMenu = (indexArray, currentCCMenu, currentCCMenuName, showReset) => {
  let initCCMenu = CCSETTINGSMENU;
  let newCCMenu = [...currentCCMenu];
  let newCCMenuName = currentCCMenuName;
  let settingName = '';
  let settingValue = '';

  // if the indexArray's length is larger than 1
  if (indexArray && indexArray.length > 1) {
    let newIndexStr = [...indexArray];
    newIndexStr.pop(); // we do not need to drill down into the last index for the submenu
    newIndexStr = newIndexStr.join('.list.'); // this will create a string like 0.list.2

    // Whether to show the reset option or not, if not it will filter out the reset menu object
    if (!showReset) {
      initCCMenu = initCCMenu.map(({ list = [], ...item }) => ({
        ...item,
        list: list.filter((listItem) => listItem.value !== 'reset'),
      }));
    }

    // gets the menu object based on the above join string using lodash
    const menuObj = get(initCCMenu, newIndexStr);
    // if the menuObj is undefined do not do anything
    if (typeof menuObj !== 'undefined') {
      // checks to see if there is another submenu
      if (Array.isArray(menuObj.list)) {
        // set the submenu items
        newCCMenu = menuObj.list;
        newCCMenuName = getName(menuObj);
      } else {
        // if there is no list it will be a setting
        settingName = camelCase(currentCCMenuName);
        settingValue = menuObj.value;
      }
    }
  } else {
    // sets the menu and menu name to the initial menu items
    newCCMenu = CCSETTINGSMENU;
    newCCMenuName = getName(CCSETTINGSMENU[0]);
  }

  return {
    currentCCMenu: newCCMenu,
    currentCCMenuName: newCCMenuName,
    settingName,
    settingValue,
  };
};

/*
 * getCCIndexFromCharacter - this will get the menu index for which menu item that first
 * starts with the passed in character
 * currentCCMenu: Array - the array of the current CC menu
 * character: String - the character in which we are looking for
 *
 * When there is a item that starts with the character it will return that index, otherwise
 * it will return -1
 */
export const getCCIndexFromCharacter = (currentCCMenu, character) => {
  const menuIndex = currentCCMenu.findIndex((i) => getName(i).startsWith(character));
  return menuIndex;
};
